import React from 'react';
import { SIZES, parseGrid, gridTotal } from '../utils/sizeGrid';

// Grade do pedido (roupa pronta): clique no tamanho para incluir/retirar da
// grade e informe a quantidade de cada um. O total vira a quantidade do item.
export default function SizeGridInput({ value, onChange, disabled = false, compact = false }) {
  const grid = parseGrid(value);
  const total = gridTotal(grid);

  function toggle(size) {
    if (disabled) return;
    const next = { ...grid };
    if (Object.prototype.hasOwnProperty.call(next, size)) delete next[size];
    else next[size] = '';
    onChange(orderGrid(next));
  }
  function setQty(size, v) {
    const n = v === '' ? '' : Math.max(0, parseInt(v, 10) || 0);
    onChange(orderGrid({ ...grid, [size]: n }));
  }
  function selectAll() {
    const next = {};
    SIZES.forEach(s => { next[s] = grid[s] ?? ''; });
    onChange(next);
  }

  const w = compact ? 52 : 60;
  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, flexWrap: 'wrap' }} data-testid="size-grid">
      {SIZES.map(size => {
        const on = Object.prototype.hasOwnProperty.call(grid, size);
        return (
          <div key={size} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, width: w }}>
            <button type="button" onClick={() => toggle(size)} disabled={disabled}
              aria-pressed={on} title={on ? `Retirar ${size} da grade` : `Incluir ${size} na grade`}
              style={{
                width: '100%', padding: '3px 0', fontSize: 11, fontWeight: 700, borderRadius: 6,
                cursor: disabled ? 'default' : 'pointer', transition: 'all 0.15s',
                border: `1.5px solid ${on ? 'var(--pantone)' : 'var(--gray-300)'}`,
                background: on ? 'var(--pantone)' : 'var(--white, #fff)',
                color: on ? 'white' : 'var(--gray-400)',
              }}>{size}</button>
            <input type="number" min="0" step="1" aria-label={`Quantidade ${size}`}
              value={on ? grid[size] : ''} disabled={!on || disabled}
              placeholder={on ? '0' : '—'}
              onChange={e => setQty(size, e.target.value)}
              style={{ width: '100%', textAlign: 'center', padding: '4px 2px', fontSize: 12 }} />
          </div>
        );
      })}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, minWidth: 64 }}>
        <span style={{ fontSize: 10, fontWeight: 700, color: 'var(--gray-500)', textTransform: 'uppercase' }}>Total</span>
        <span data-testid="size-grid-total"
          style={{ fontFamily: 'var(--font-mono)', fontWeight: 700, fontSize: 14, color: total ? 'var(--pantone)' : 'var(--gray-300)', lineHeight: '26px' }}>
          {total || '—'}
        </span>
      </div>
      {!disabled && Object.keys(grid).length < SIZES.length && (
        <button type="button" className="btn btn-ghost btn-sm" onClick={selectAll}
          style={{ fontSize: 11, padding: '4px 8px', whiteSpace: 'nowrap' }}>XXS→L</button>
      )}
    </div>
  );
}

function orderGrid(g) {
  const out = {};
  SIZES.forEach(s => { if (Object.prototype.hasOwnProperty.call(g, s)) out[s] = g[s]; });
  return out;
}
